module.exports = __webpack_public_path__ + "cafea51588604beff53b566d659b0401.svg";